module.exports = __webpack_public_path__ + "static/media/Piet_500px.4ee643f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Piet_500px.png
// module id = 259
// module chunks = 0